module.exports = __webpack_public_path__ + "img/login.0942bb40.jpg";